module.exports = __webpack_public_path__ + "public/img/top-bg.a0a519ea.png";